import type { CurrencyCode } from 'types/currency';

type ActivityMessage = {
  id: string;
  is_system: boolean;
  body: string;
  author: string | null;
  owner: boolean;
  attachment_url: string | null;
  attachment_name: string | null;
  date: string;
};

type ActivityConversation = {
  id: string;
  unread: boolean;
  messages: ActivityMessage[];
};

export type InvoiceFeedback = {
  id: number;
  closed: boolean;
  has_tp_case_pdf: boolean | null;
  third_party_case_id: number | null;
  conversation: ActivityConversation;
} | null;

export enum EmailDeliveryStatus {
  PROCESSED = 'processed',
  DELIVERED = 'delivered',
  OPEN = 'open',
  CLICK = 'click',
  BOUNCE = 'bounce',
  DROPPED = 'dropped',
  DEFERRED = 'deferred',
}

export type Activity = {
  activity_type:
    | 'comment'
    | 'payment'
    | 'invoice'
    | 'dispute'
    | 'pause'
    | 'lawyer'
    | 'bailiff'
    | 'reminders'
    | 'preference'
    | 'formal_notice';
  attachment_url: string;
  author: string;
  comment: string;
  date: Date;
  description: string;
  document_type: string;
  email_statuses?: {
    [_key in EmailDeliveryStatus]?: Array<string>;
  };
  end_pause_at: Date;
  has_document: boolean;
  document_id?: number;
  id: number;
  invoice_feedback: InvoiceFeedback;
  linked_credit_note_id?: number;
  new: boolean;
  payment_information: ActivityPaymentInfo;
  payment_plan_id: number;
  reason: string;
  tracked_id: number;
  tracked_type: 'Invoice' | 'CreditNote' | 'Debtor' | 'Question' | 'CompanyDetail' | 'Task';
  reminder?: {
    id: string;
    wasSentByMail: boolean;
    wasSentByPost: boolean;
  };
};

export type AmountLocalizedMoneyObject = {
  currency: CurrencyCode;
  amount: number;
};

export type ActivityPaymentInfo = {
  currency: CurrencyCode;
  amount: number;
  modality: string;
  date: Date;
  counterparty_name: string;
  notes: string;
  external_id: string;
  localized_money_object: AmountLocalizedMoneyObject;
};
